import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { connect } from 'react-redux';
import CefMobilePageWrapper from "../../Layout/Wrappers/CefMobilePageWrapper";
import Content from "./Content";
import { getApplication } from "../../../../store/Selectors";
import { setField as setFieldActionCreator } from "../../../../store/Actions/Actions";
import { Keys, Routes, countries } from "../../Common/Constants";
import { FooterButton } from "./FooterButton";
import useCefNavigation from "../../Hooks/useCefNavigation";
import Question from "../../Common/Question";
import { useCountries } from "../../../../data";
var UnconnectedNationalityQuestion = function UnconnectedNationalityQuestion(_ref) {
  var onExit = _ref.onExit,
    onSave = _ref.onSave,
    nationality = _ref.nationality,
    setField = _ref.setField;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var navigate = useCefNavigation();
  var pushLocation = function pushLocation() {
    var route = '';
    if ((nationality === null || nationality === void 0 ? void 0 : nationality.code) === countries.India.code) {
      route = Routes.Eligibility.ProvinceOfResidenceQuestion;
    } else {
      setField({
        key: Keys.Application.stateOfResidence,
        value: null
      });
      route = Routes.Eligibility.HighestEducationQuestion;
    }
    setField({
      key: Keys.Application.countryOfResidence,
      value: nationality
    });
    setField({
      key: Keys.Application.educationCountry,
      value: nationality
    });
    navigate(route);
  };
  var _useCountries = useCountries(),
    countriesData = _useCountries.countries,
    isLoadingCountries = _useCountries.isLoadingCountries;
  return /*#__PURE__*/React.createElement(CefMobilePageWrapper, {
    onExit: onExit,
    onSave: onSave,
    footerButton: isLoadingCountries ? null : /*#__PURE__*/React.createElement(FooterButton, {
      countriesData: countriesData,
      nationality: nationality,
      pushLocation: pushLocation,
      setErrorMessage: setErrorMessage
    })
  }, /*#__PURE__*/React.createElement(Question, {
    keyName: Keys.Application.nationality
  }), /*#__PURE__*/React.createElement(Content, {
    countriesData: countriesData,
    errorMessage: errorMessage,
    isLoading: isLoadingCountries,
    nationality: nationality,
    setErrorMessage: setErrorMessage,
    setField: setField
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  var application = getApplication(state);
  return {
    nationality: application.nationality
  };
};
var connector = connect(mapStateToProps, {
  setField: setFieldActionCreator
});
var NationalityQuestion = connector(UnconnectedNationalityQuestion);
export default NationalityQuestion;